import axios from "axios";

const SYNC_API_BASE_URL = "https://sync.forgedrift.com/api";

const earlyAccessClient = axios.create({
  baseURL: SYNC_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const createEarlyAccessProfile = (payload) =>
  earlyAccessClient.patch("/createEarlyAccessProfile", {
    data: {
      schoolName: payload.schoolName,
      yourName: payload.yourName,
      role: payload.role,
      email: payload.email,
      phoneNumber: payload.phoneNumber,
      numberOfStudents: payload.numberOfStudents,
    },
  });
